import React from "react"

import "./PoweredByFider.scss"

export const PoweredByFider = () => {
  return (
    <div className="c-powered">
      <a rel="noopener" href="https://getfider.com" target="_blank">
        Powered by Fider
      </a>
    </div>
  )
}
